<template>
    <v-text-field v-model="username" v-bind="attrs" @input="emit" @blur="checkUsername" />
</template>

<script>
import api from "@/api";
export default {
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        username: null,
        isOkay: undefined,

        loading: false,
    }),
    computed: {
        attrs() {
            let { loading, rules = [] } = this.$attrs;

            loading = loading || this.loading;
            if (typeof this.isOkay == "string") rules = rules.concat(this.isOkay);

            return { ...this.$attrs, loading, rules };
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.username = this.value;
        },
        emit() {
            this.$emit("input", this.username);
        },
        async checkUsername() {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { username } = this;
                await api.v1.users.checkUsername.post({ username });
                this.isOkay = true;
            } catch (error) {
                this.isOkay = error.response.data.message;
            } finally {
                this.isOkay = this.isOkay || true;
                this.loading = false;
            }
        },
    },
};
</script>

<style>
</style>